module.exports = __webpack_public_path__ + "img/delAccModal.7b5e7f6c.png";